import {Folder} from '../../../Assets.types';

/**
 * Find folder by ID in tree recursively
 * @param assetTree - The tree structure to search
 * @param folderId - ID of the folder to find
 * @returns The folder object if found, null otherwise
 */
export default function findFolderInTree(
  assetTree: Folder | null,
  folderId: number,
): Folder | null {
  if (!assetTree) {
    return null;
  }

  if (assetTree.folderId === folderId) {
    return assetTree;
  }

  if (assetTree.folders) {
    for (const folder of assetTree.folders) {
      const found = findFolderInTree(folder, folderId);

      if (found) {
        return found;
      }
    }
  }

  return null;
}

